
import React, { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Switch,
  styled,
  IconButton,
} from '@mui/material';

/// Custom styled black & white switch
const BlackWhiteSwitches = styled(Switch)(() => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#000',
      '& + .MuiSwitch-track': {
        backgroundColor: '#000',
      },
    },
    '& .MuiSwitch-switchBase': {
      color: '#ccc',
    },
    '& .MuiSwitch-track': {
      backgroundColor: '#ccc',
    },
  }));

  
  

const BlackWhiteSwitch = () => {
    const [isActive, setIsActive] = React.useState(true);

    const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsActive(event.target.checked);
      };
  return (
   <>
   <div className="statusWrap">
    <label>Status</label>
    <Box display="flex" alignItems="center" gap={2}>
      <BlackWhiteSwitches checked={isActive} onChange={handleToggle} />
      <Typography variant="body1" color={isActive ? 'green' : '#888'}>
        {isActive ? 'Active' : 'Inactive'}
      </Typography>
    </Box>
   </div>
    
   </>
    
  )
}

export default BlackWhiteSwitch